import { lsGet, safeAwait } from 'utils/request'

export const getArticleById = (id) => {
  return safeAwait(lsGet(`/articles/${id}`))
}
